import { CheckBox } from 'views/components/atoms/checkBox';
import { Label } from 'views/components/atoms/label';
import { ListBodyCellType } from 'views/components/atoms/listCell';
import { BodyShowList } from 'views/components/molecules/listBody';
import { BgColors } from 'views/constants/enums/bgColors';
import { GetIssuanceDocumentListQuery, IssuanceDocumentInfo } from 'views/utils/graphql/graphql';

export const createBodyShowLists = (
  data: GetIssuanceDocumentListQuery,
  selectedItems: IssuanceDocumentInfo[],
  setSelectedItems: React.Dispatch<React.SetStateAction<IssuanceDocumentInfo[]>>,
) => {
  if (!data.GetIssuanceDocumentList?.Data) return [];

  const createdBodyShowLists: BodyShowList[] = data.GetIssuanceDocumentList?.Data?.map((item) => [
    {
      type: ListBodyCellType.checkCell,
      label: (
        <CheckBox
          checked={selectedItems.some((doc) => doc.ID === item?.ID)}
          onChange={(checked) => {
            if (checked) {
              setSelectedItems([...selectedItems, item!]);
            } else {
              setSelectedItems(selectedItems.filter((doc) => doc.ID !== item?.ID));
            }
          }}
        />
      ),
    },
    {
      type: ListBodyCellType.nameCell,
      label: <div>{item?.DisplayName}</div>,
    },
    {
      type: ListBodyCellType.dateCell,
      label: <div>{item?.IssueDate}</div>,
    },
  ]);
  return createdBodyShowLists;
};
